import { Plugin, PluginId } from "..";

const id: PluginId = "map_plugin";

export const MapPlugin: Plugin = {
	id,
	type: "history",
	header: {
		visible: false,
	},
	name: "map",
	currentVersion: 1,
	component: defineAsyncComponent(() => import("./MapPlugin.vue")),
	config: defineAsyncComponent(() => import("./MapPluginConfig.vue")),
	dataConfig: null,
	defaultDataResolver: () => undefined,
	defaultOptionsResolver: () => undefined,
	migrations: {},
};
